// ProductType Vuex

import state from './nearExpiryStates.js'
import * as getters from './nearExpiryGetters.js'
import * as mutations from './nearExpiryMutations.js'
import * as actions from './nearExpiryActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
